import buildUrl from 'modules/core/lib/buildUrl'

import { datasourceTypeFromId } from 'modules/ai_reports/components/DatasourceTypeRenderer/utils'

function bytesToBase64(bytes: Uint8Array) {
  const binString = Array.from(bytes, (byte) => String.fromCodePoint(byte)).join('')
  return btoa(binString)
}

export const exportReport = (
  reportName: string,
  sqlQuery: string,
  companyId: number,
  datasourceId: string,
  dateFilter: { snapshotDate?: Date; dateRange?: { from: Date; to: Date } }
) => {
  const filename = reportName ? `${reportName}.csv` : 'export.csv'
  const params = new URLSearchParams({
    sql_query: bytesToBase64(new TextEncoder().encode(sqlQuery ?? '')),
    company_id: companyId.toString(),
    table_id: datasourceId,
    filename,
  })
  const datasourceType = datasourceTypeFromId(datasourceId)
  if (datasourceType === 'snapshot') {
    params.set('snapshot_date', dateFilter.snapshotDate?.toISOString() ?? '')
  }
  if (datasourceType === 'traceability') {
    params.set('date_range[from]', dateFilter.dateRange?.from.toISOString() ?? '')
    params.set('date_range[to]', dateFilter.dateRange?.to.toISOString() ?? '')
  }
  const url = buildUrl(`/iris/analytics_exports_${datasourceType}/download?${params.toString()}`)

  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
